"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var os = require("os");
var path = require("path");
var dyna_guid_1 = require("dyna-guid");
var node_1 = require("dyna-disk-memory/dist/commonJs/node");
exports.createDisk = function () {
    var diskPath = path.join(os.tmpdir(), 'server-services', dyna_guid_1.guid());
    var memory = new node_1.DynaDiskMemory({
        diskPath: diskPath,
    });
    return {
        set: function (key, data) { return memory.set('c', key, data); },
        get: function (key) { return memory.get('c', key); },
        del: function (key) { return memory.del('c', key); },
        delAll: function () { return memory.delContainer('c'); },
    };
};
//# sourceMappingURL=createDisk.js.map